package com.gsb.vyapar.bhagya.presentation.category.manager

import com.gsb.vyapar.bhagya.datasource.cache.SqlDelightClient
import com.gsb.vyapar.bhagya.datasource.network.KtorClient
import com.gsb.vyapar.bhagya.domain.Categories
import com.gsb.vyapar.bhagya.domain.SubCategories
import com.gsb.vyapar.bhagya.domain.toCategoryList
import com.gsb.vyapar.bhagya.domain.toSubCategoryList
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.util.hideLoading
import com.gsb.vyapar.bhagya.interactor.util.saveCategories
import com.gsb.vyapar.bhagya.interactor.util.saveSubCategories
import com.gsb.vyapar.bhagya.interactor.util.showError
import com.gsb.vyapar.bhagya.interactor.util.showLoading
import com.gsb.vyapar.bhagya.interactor.util.uploadImage
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.bottomsheet.BottomSheets
import com.gsb.vyapar.bhagya.presentation.bottomsheet.util.hideBottomSheet
import com.gsb.vyapar.bhagya.presentation.bottomsheet.util.showBottomSheet
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.category.event.CategoriesViewUiEvents
import com.gsb.vyapar.bhagya.presentation.category.uistate.getAddEditCategory
import com.gsb.vyapar.bhagya.presentation.category.uistate.getAddEditSubCategory
import com.gsb.vyapar.bhagya.presentation.category.uistate.getCategoriesViewUiState
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.util.getMessage

object CategoriesViewManager {
    fun onTriggerEvent(event: CategoriesViewUiEvents) {
        when (event) {
            is CategoriesViewUiEvents.AddEditCategoryDeleted -> getCategoriesViewUiState().setCategoryDeleted(event.deleted)
            is CategoriesViewUiEvents.AddEditCategoryImageUpload -> uploadCategoryImage(event.image, event.fileName)
            is CategoriesViewUiEvents.AddEditCategoryName -> getCategoriesViewUiState().setCategoryName(event.name)
            CategoriesViewUiEvents.AddEditCategorySave -> saveCategory()
            CategoriesViewUiEvents.SaveCategories -> saveCategories()
            CategoriesViewUiEvents.SaveSubCategories -> saveSubCategories()
            is CategoriesViewUiEvents.AddEditCategory -> addEditCategory(event.addEditCategory)
            is CategoriesViewUiEvents.AddEditSubCategoryCategoryMenuIndex -> addEditSubCategoryCategoryMenuIndex(event.categoryMenuIndex)
            is CategoriesViewUiEvents.AddEditSubCategoryDeleted -> getCategoriesViewUiState().setSubCategoryDeleted(event.deleted)
            is CategoriesViewUiEvents.AddEditSubCategoryName -> getCategoriesViewUiState().setSubCategoryName(event.name)
            is CategoriesViewUiEvents.AddEditSubCategory -> addEditSubCategory(event.addEditSubCategory)
            CategoriesViewUiEvents.AddEditSubCategorySave -> saveSubCategory()
            is CategoriesViewUiEvents.ShowCategory -> showCategory(event.category)
        }
    }

    private fun showCategory(category: Categories.D.Category?) {
        getCategoriesViewUiState().updateBusinessDetail(null)
        getCategoriesViewUiState().updateCategory(category)
        getBusinessUiState().updateFilteredBusinessList(category)
        pushView(Screens.Category)
    }

    private fun addEditSubCategoryCategoryMenuIndex(categoryMenuIndex: Int) {
        getCategoriesViewUiState().setSubCategoryCategoryMenuIndex(categoryMenuIndex)
        val category = getState().getCategories().getCategoriesList().find { it.name == getCategoriesViewUiState().selectCategoryMenuOptions[categoryMenuIndex] }
        category?.let { getCategoriesViewUiState().setSubCategoryCategoryId(it.id) }
    }

    private fun addEditCategory(addEditCategory: Categories.D.Category?) {
        getCategoriesViewUiState().setCategory(addEditCategory)
        showBottomSheet(BottomSheets.AddEditCategory)
    }

    private fun addEditSubCategory(addEditSubCategory: SubCategories.D.SubCategory?) {
        val categories = getState().getCategories().getCategoriesList()
        val menuOptions = categories.map { it.name }
        getCategoriesViewUiState().setSubCategory(addEditSubCategory)
        getCategoriesViewUiState().setCategoryMenuOptions(menuOptions)
        getCategoriesViewUiState().setSubCategoryCategoryMenuIndex(menuOptions.indexOf(categories.find { it.id == addEditSubCategory?.categoryId }?.name))
        showBottomSheet(BottomSheets.AddEditSubCategory)
    }

    private fun saveCategory() {
        val addEditCategory = getAddEditCategory()
        if (addEditCategory.name.isNotEmpty() && addEditCategory.imageUrl.isNotEmpty()) {
            showLoading()
            launchDefault {
                SqlDelightClient.insertOrUpdateCategory(addEditCategory)
                val categories = SqlDelightClient.getCategories().toCategoryList()
                saveCategories(categories)
                hideLoading()
                hideBottomSheet()
            }
        } else {
            showError("Please fill all the details")
        }
    }

    private fun saveSubCategory() {
        val addEditSubCategory = getAddEditSubCategory()
        if (addEditSubCategory.name.isNotEmpty() && addEditSubCategory.categoryId != -1L) {
            showLoading()
            launchDefault {
                SqlDelightClient.insertOrUpdateSubCategory(addEditSubCategory)
                val subCategories = SqlDelightClient.getSubCategories().toSubCategoryList()
                saveSubCategories(subCategories)
                hideLoading()
                hideBottomSheet()
            }
        } else {
            showError("Please fill all the details")
        }
    }

    private fun saveCategories() {
        showLoading()
        launchDefault {
            var categories = getState().getCategories()
            categories = categories.copy(v = categories.v + 1)
            val result = KtorClient.updateCategories(categories)
            if (!result.isSuccess) {
                showError("Save Categories failed ${result.exceptionOrNull()?.getMessage()}")
            }
            hideLoading()
        }
    }

    private fun saveSubCategories() {
        showLoading()
        launchDefault {
            var subCategories = getState().getSubCategories()
            subCategories = subCategories.copy(v = subCategories.v + 1)
            val result = KtorClient.updateSubCategories(subCategories)
            if (!result.isSuccess) {
                showError("Save SubCategories failed ${result.exceptionOrNull()?.getMessage()}")
            }
            hideLoading()
        }
    }

    private fun uploadCategoryImage(data: ByteArray, fileName: String) {
        uploadImage(data, fileName) {
            getCategoriesViewUiState().setCategoryImageUrl(it)
        }
    }
}